import { SYSBaseElement, SYSConfig, html } from "../../../../_ovlclient/src"
import {
  ProcessIsRunning,
  ProcessIsServerAccessRunning,
} from "../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import {
  ScreenCurrent,
  ScreenRefresh,
} from "../../../../_ovlclient/src/library/screenapi"
import { T } from "../../../../_ovlclient/src/textapi"

export class CompSYSRefreshButton extends SYSBaseElement {
  async getUI() {
    let screen = ScreenCurrent()
    let refreshIsRunning = ProcessIsServerAccessRunning()
    const handleRefresh = async (e: Event) => {
      if (!refreshIsRunning) {
        //call the screens refresh action if any
        await ScreenRefresh(screen, { triggeredFromRefreshMenu: true })
      }
    }

    let buttonInactive = refreshIsRunning ? "ovl-disabled" : ""

    let refresh
    let offline
    if (SYSConfig.offline.enabled && this.state.ovl.app.offline.api) {
      let offlineIndicatorText = T("SYSOfflineIndicator", undefined, "Empty")
      if (!offlineIndicatorText) {
        offlineIndicatorText = "OFF"
      }
      offline = html`<span class="ovl-offline-indicator"
        >${offlineIndicatorText}</span
      >`
    }
    if (refreshIsRunning) {
      refresh = html`
        <span
          class="ovl-refresh ovl-rotatingrefresh sap-icon--synchronize rotate fd-has-color-action-2"
        ></span>
      `
    } else if (this.actions.app.screens[screen]?.hooks?.HookScreenRefresh) {
      refresh = html`<button
        @click=${handleRefresh}
        class=${`fd-button fd-shellbar__button ovl-refreshbutton fd-has-color-action-2 ${buttonInactive}`}
        title=${T("GENRefreshData")}
        aria-label=""
      >
        <span
          class="sap-icon--refresh ovl-refresh fd-has-color-action-2"
        ></span>
      </button>`
    }

    return html` <span> ${refresh} ${offline} </span> `
  }
}
